var map = {
	"./battery_5blue.png": "f2ec",
	"./battery_5classic.png": "1c1f",
	"./battery_5disable.png": "9264",
	"./battery_5green.png": "d83e",
	"./battery_5orange.png": "2f8c",
	"./battery_5purple.png": "da27"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b8dd";